
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'CombinationsWarning',
})
export default class CombinationsWarning extends Vue {
    @Prop({ type: String, required: true }) readonly message!: string;
}
